import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  list: [],
  total: 0,
  detail: {},
  error: null,
};

const healthTypeSlice = createSlice({
  name: "healthType",
  initialState,
  reducers: {
    // GET LIST
    getHealthTypeListRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getHealthTypeListSuccess: {
      reducer: (state, action) => {
        const { docs, totalDocs } = action.payload;
        return {
          ...state,
          isLoading: false,
          list: docs || [],
          total: totalDocs || 0,
          error: null,
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getHealthTypeListFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // GET ALL (No pagination)
    getHealthTypeAllRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getHealthTypeAllSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        list: action.payload || [],
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getHealthTypeAllFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // CREATE
    createHealthTypeRequest: {
      reducer: (state) => ({
        ...state,
        isCreating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createHealthTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isCreating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createHealthTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isCreating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // UPDATE
    updateHealthTypeRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateHealthTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateHealthTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // DELETE
    deleteHealthTypeRequest: {
      reducer: (state) => ({
        ...state,
        isDeleting: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteHealthTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isDeleting: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    deleteHealthTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isDeleting: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // RESTORE
    restoreHealthTypeRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    restoreHealthTypeSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    restoreHealthTypeFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
  },
});

export const {
  getHealthTypeListRequest,
  getHealthTypeListSuccess,
  getHealthTypeListFailure,
  getHealthTypeAllRequest,
  getHealthTypeAllSuccess,
  getHealthTypeAllFailure,
  createHealthTypeRequest,
  createHealthTypeSuccess,
  createHealthTypeFailure,
  updateHealthTypeRequest,
  updateHealthTypeSuccess,
  updateHealthTypeFailure,
  deleteHealthTypeRequest,
  deleteHealthTypeSuccess,
  deleteHealthTypeFailure,
  restoreHealthTypeRequest,
  restoreHealthTypeSuccess,
  restoreHealthTypeFailure,
} = healthTypeSlice.actions;

export default healthTypeSlice.reducer;
